import { Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'loading',
  standalone: true,
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
})
export class LoadingComponent {
  constructor(readonly loadingService: LoadingService) {
  }
}
